<template>
	<div class="text_item">
		<div class="text_item__label">{{ label }}</div>
		<div class="text_item__value">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TextItem',
	props: {
		label: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="less">
	.text_item {
		.flex();
		&__label {
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			line-height: 34px;
			color: #8F959E;
		}
		&__value {
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			line-height: 34px;
			text-align: right;
			color: #1F2329;
		}
	}
</style>
